import { Activity, AlertCircle } from "react-feather";
import { TableColumn } from "../../types";
import { Tooltip } from "../../../../components/Tooltip";
import { WorkloadTableItem, parseReadiness } from "../../../../mst/kinds/workload.helpers";

const readinessDefault = { id: "readiness", label: "Readiness" };
export function WorkloadReadinessColumn<TData extends WorkloadTableItem>(
  column: TableColumn<TData> = readinessDefault,
) {
  const preset: TableColumn<TData> = {
    ...readinessDefault,
    enableHide: true,
    enableSort: true,
    serverSortProperty: "health.readiness",
    size: 150,
    cell: (p) => {
      const workload = p.row.original;
      const readiness = parseReadiness(workload.health?.readiness);
      const isReady = readiness === "latestReady" || readiness === "ready";
      const syncFailed = workload.health?.syncFailed === true;
      const isLatestReady = readiness === "latestReady";

      return (
        <div className="flex items-center">
          <Activity
            style={{ width: 16, marginRight: "0.25rem" }}
            className={`h-4 ${isReady ? "color-action" : "color-danger"}`}
          />
          <span>{isReady ? "Ready" : "Not Ready"}</span>
          {syncFailed || (isReady && !isLatestReady) ? (
            <Tooltip
              title={
                <div>
                  {syncFailed ? (
                    <div>There are stale deployments.</div>
                  ) : (
                    <div>Latest version is not ready in all locations.</div>
                  )}
                </div>
              }
            >
              <AlertCircle className="h-4" />
            </Tooltip>
          ) : null}
        </div>
      );
    },
  };
  return Object.assign(preset, column);
}
